import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Infographic from '../Infographic/Infographic';

function Section2() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/over-10-years-homeowners-obtained-240k-in-equity',
      copy: 'NAR data shows',
      label: "Visit Dr. Jessica Lautz's bio page"
    }
  ];
  return (
    <section className="sections">
      <h2 className="sections-title">HOW REPEAT BUYERS ACCUMULATE THAT EQUITY ADVANTAGE</h2>
      <p className="sections-copy">
        Think of it this way – the monthly payments that renters make go into the bank account of a
        landlord. For the vast majority of homeowners with mortgages, while some of their monthly
        payment goes toward paying interest on the loan, the rest of that payment is applied to
        reducing the debt – also known as the “principal” amount owed.
      </p>
      <p className="sections-copy">
        As long as the homeowner continues to make mortgage payments on time every month, the
        principal steadily drops and the homeowner (rather than the lender) owns a larger percentage
        of the value of the home. Since “equity” is generally defined as the difference between what
        the homeowner owes and what the home is worth, equity climbs as the homeowner pays off the
        mortgage loan.
      </p>
      <div className="sections__float">
        <Infographic />
        <p className="sections-copy">
          But equity can also climb if the value of the home increases over time. In fact, that’s
          been the major driver of rising homeowner equity in recent years.{' '}
          <Hyperlink hyperlinkData={hyperlinkData[0]} /> that the median homeowner gained around
          $31,000 in equity by paying down mortgage debt over the past decade. But during that same
          time period, price gains added over $209,000 in equity, helping the median homeowner
          accumulate $240,000 in housing wealth within a decade.
        </p>
      </div>
      <p className="sections-copy">
        Homeowners can use this equity to their advantage when looking for their next home. They can
        borrow against the home equity to fund a down payment on a new home. Or they can sell their
        current home and then use whatever equity is left after paying off existing mortgage debt to
        help fund an offer on a new home. For repeat homebuyers who are downsizing or moving to a
        less expensive area, they may even be able to use their equity to fund an all-cash purchase
        of their new home, which can make their bid more appealing to sellers who don’t have to
        worry about buyer financing falling through.
      </p>
    </section>
  );
}

export default Section2;
